import { isObject } from './isObject';

export const isPlainObject = (unknown: unknown) => {
  const prototype = isObject(unknown) && Object.getPrototypeOf(unknown);
  return prototype === null || prototype === Object.prototype;
};
